import React from "react";
import "./CheckOutProcess.css";
import { Offcanvas } from "react-bootstrap";
import YellowFilledRoundBtn from "../../Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
import OrangeFilledRoundBtn from "../../Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const CheckOutProcessOffCanvas = ({
  data,
  checkOutProcessBaseLink,
  ...props
}) => {
  const navigate = useNavigate();

  const handleProceed = () => {
    // Collect data before navigating
    

    // Navigate with state
    navigate(checkOutProcessBaseLink, { state: data });
  };
  
  return (
    <section>
      <Offcanvas
        {...props}
        className="CheckOutProcessOffCanvas"
        placement="bottom"
      >
        <Offcanvas.Body>
          <div className="content_holder">
            <div className="left_side">
              <p className="first_text">Upload your design, </p>
              <p className="last_text">
                then continue to the{" "}
                <b>checkout process to complete your order</b>
              </p>
            </div>

            <div className="right_side">
              <div
                className="create_file_btn"
                onClick={() => {
                  props?.onHide();
                }}
              >
                <YellowFilledRoundBtn btnText="Back" />
              </div>
              {/* <Link to={checkOutProcessBaseLink}> */}
              {/* <Link
                to={{
                  pathname: checkOutProcessBaseLink,
                  state:data ,
                }}
              > */}
                <div className="upload_file_btn" onClick={handleProceed}>
                  <OrangeFilledRoundBtn btnText="Save & Proceed" />
                </div>
              {/* </Link> */}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
};

export default CheckOutProcessOffCanvas;
